export default __webpack_public_path__ + "static/media/Group1624.a14e93ae.png";